export default {
  name: "promotion-notification",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
